<template>
  <modal title="Delete Search" size="xs" ref="modal">
    <h2 class="text-subtitle1">
      Are you sure you want to delete this search?
    </h2>
    <template v-slot:actions>
      <async-btn label="Delete" color="negative" :task="task" @click="remove" />
    </template>
  </modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ModalMixin } from '@/mixins';
import { Modal as ModalElement, PostSearch } from '@/type';
import Modal from '@/components/modal/Modal.vue';
import AsyncBtn from '@/components/AsyncBtn.vue';
import notify from '@/components/notify';
import { remove } from '.';

interface Data {
  task: Promise<void>|undefined
}

export default defineComponent({
  emits: ['ok'],
  mixins: [ModalMixin],
  components: {
    Modal,
    AsyncBtn,
  },
  props: {
    postSearch: {
      type: Object as () => PostSearch,
      required: true,
    },
  },
  data(): Data {
    return {
      task: undefined,
    };
  },
  methods: {
    remove() {
      this.task = remove(this.postSearch.id);
      this.task.then(() => {
        this.$emit('ok');
        (this.$refs.modal as ModalElement).hide();
        notify('Search deleted.');
      });
    },
  },
});
</script>
